"use client";

import { useDevice } from "./useDevice";

export type TypographyVariant =
  // Standard variants
  | "h4"
  | "h5"
  | "h6"
  | "subtitle1"
  | "subtitle2"
  | "body1"
  | "body2"
  | "caption"
  | "overline"
  // Component variants
  | "badgeLabel"
  | "buttonLarge"
  | "buttonMedium"
  | "buttonSmall"
  | "chip"
  | "helperText"
  | "inputText"
  | "inputLabel"
  | "menuItem"
  | "tooltip"
  | "campaignStatus"
  | "notice"
  | "linkTitle"
  | "linkSubtitle";

// Map typography variants to Tailwind classes
const variantToClassName: Record<TypographyVariant, string> = {
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "body1 font-medium",
  subtitle2: "body2 font-medium",
  body1: "body1",
  body2: "body2",
  caption: "caption",
  overline: "caption uppercase tracking-wider",
  badgeLabel: "caption font-semibold",
  buttonLarge: "btn-large",
  buttonMedium: "btn-medium",
  buttonSmall: "btn-small",
  chip: "caption font-medium",
  helperText: "caption text-cede-text-secondary",
  inputText: "body1",
  inputLabel: "body2 font-medium",
  menuItem: "body2",
  tooltip: "caption",
  campaignStatus: "caption font-semibold uppercase",
  notice: "body2",
  linkTitle: "body1 font-medium",
  linkSubtitle: "body2 text-cede-text-secondary",
};

export const useResponsiveTypography = (
  mobile: TypographyVariant,
  tablet: TypographyVariant,
  desktop: TypographyVariant,
): string => {
  const { isMobile, isTablet } = useDevice();

  const variant = isMobile ? mobile : isTablet ? tablet : desktop;
  return variantToClassName[variant];
};
